export const addQueryString = function addQueryString(url, params) {
    if (params && typeof params === 'object') {
      let queryString = '';
  
      for (const paramName in params) {
        queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
      }
  
      if (!queryString) return url;
      url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
    }
  
    return url;
};

export const toAssetUrl = (path = "") => {
    const base = `https://${process.env.REACT_APP_WHITELABEL}-assets.socialscavenger.com/images/`;
  
    // If it's already a full URL, return as-is
    if (/^(https?:)?\/\//i.test(path)) {
      return path;
    }
  
    // Otherwise, prepend the base
    return `${base}${path.replace(/^\/+/, "")}`;
}
  